
import Vue from 'vue'

export default Vue.extend({
  name: 'ChefBookCompanyAddress',
  props: {
    vat_company_address: {
      type: Object,
      required: true
    }
  },
})
